import React from 'react';
import styled from 'styled-components';

import Button from '../global/Button';
import CardContainer from '../global/CardContainer';
import CCContentFlex from '../global/CardContainer/CCContentFlex';
import CCContentWrapper from '../global/CardContainer/CCContentWrapper';
import CCImage from '../global/CardContainer/CCImage';
import H1 from '../global/typography/H1';
import HeadingCallout from '../global/typography/HeaderCallout';
import NavLink from '../global/NavLink';
import P from '../global/typography/P';

const StyledCardContainer = styled(CardContainer)`
  z-index: 10;
  box-shadow: none;
  justify-content: center;

  @media (max-width: ${props => props.theme.deviceWidth.tablet}) {
    padding: 0;
  }
`;

const StyledCCImage = styled(CCImage)`
  width: 40%;
  padding: 30px;

  @media (max-width: ${props => props.theme.deviceWidth.tablet}) {
    padding: 10px 10px 0 0;
  }

  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    width: 50%;
    margin: 0 auto;
  }
`;

const Content = styled(CCContentWrapper)`
  max-width: 50%;
  margin-left: -60px;

  @media (max-width: 1110px) {
    max-width: 70%;
  }

  @media (max-width: ${props => props.theme.deviceWidth.tablet}) {
    margin-left: 0;
    max-width: 70%;
    padding: 30px;
  }

  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    margin-left: 0;
    max-width: 100%;
    padding: 30px;
  }
`;

const SmallButton = styled(Button)`
  margin-right: 8px;
`;

const Buttons = styled.div`
  width: 100%;
`;

const PackageCard = () => (
  <StyledCardContainer flex pullUp>
    <StyledCCImage
      image={{
        src: 'home/noble.png',
        alt: 'Picture of wall and floor mount noble'
      }}
    />
    <Content>
      <div>
        <HeadingCallout>Residential Combi Boiler</HeadingCallout>
        <H1>
          Noble<sup>&reg;</sup> combination gas boiler/space heating appliance
        </H1>
      </div>
      <CCContentFlex>
        <P>
          With three models ranging from 110,000 to 199,000 Btu/hr., the Noble
  combi boiler offers easy installation and serviceability, true instantaneous
  response time and a user-friendly interface. In addition to 10:1 turndown and
  95 percent Annual Fuel Utilization Efficiency (AFUE), the Noble Fire Tube
  Combi Boiler is designed, engineered and assembled in the USA.
        </P>
      </CCContentFlex>
      <Buttons>
        <NavLink to="/products/residential-boilers/noble-fire-tube-combi-boiler">
          <SmallButton>View Product</SmallButton>
        </NavLink>
      </Buttons>
    </Content>
  </StyledCardContainer>
);

export default PackageCard;
